import { makeStyles } from "tss-react/mui";

const useBaseLayoutStyles = makeStyles()((theme) => ({
  layout: {
    maxWidth: "600px",
    margin: "0 auto",
    backgroundColor: theme.palette.common.white,
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    color: theme.palette.common.black,
  },
}));

export default useBaseLayoutStyles;
